import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const Index = () => import('./Index.vue');
const NewBot = () => import('./NewBot.vue');
const Show = () => import('./Show.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Index,
          meta: { permissions: ['administrator'] },
        },
        {
          path: 'new',
          name: 'agent_bots_new',
          component: NewBot,
          meta: { permissions: ['administrator'] },
        },
        {
          path: ':id',
          name: 'agent_bot_show',
          component: Show,
          meta: { permissions: ['administrator'] },
          props: true,
        },
      ],
    },
  ],
};
